<template>
  <div class="store-statistic-container">
    <div class="section-header">
      <div class="header-line"></div>
      <span class="section-title">门店加工订单统计</span>
    </div>
    <div class="statistic-grid">
      <div class="statistic-card" v-for="(item, index) in statisticItems" :key="index">
        <div class="card-icon" :style="{ background: item.bgColor }">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="card-content">
          <div class="card-label">{{ item.label }}</div>
          <div class="card-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetStoreOrderNumStatistics } from "@/api/storeOrderApi.js";
export default {
  data() {
    return {
      loading: false,
      statisticData: {
        todayCount: 0,
        sevenCount: 0,
        monthCount: 0,
        yearCount: 0,
        totalCount: 0,
        doingCount: 0,
      },
    };
  },
  computed: {
    statisticItems() {
      return [
        { label: "加工中", value: this.statisticData.doingCount, bgColor: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)" },
        { label: "今日订单", value: this.statisticData.todayCount, bgColor: "linear-gradient(135deg, #1a96c7 0%, #1479a3 100%)" },
        { label: "近7天订单", value: this.statisticData.sevenCount, bgColor: "linear-gradient(135deg, #ca4545 0%, #a83838 100%)" },
        { label: "本月订单", value: this.statisticData.monthCount, bgColor: "linear-gradient(135deg, #dd912c 0%, #bf7a24 100%)" },
        { label: "本年订单", value: this.statisticData.yearCount, bgColor: "linear-gradient(135deg, #1eda3d 0%, #17b030 100%)" },
        { label: "累计订单", value: this.statisticData.totalCount, bgColor: "linear-gradient(135deg, #8736e4 0%, #6b2db0 100%)" },
      ];
    },
  },
  components: {},

  created() {
    this.GetStoreOrderNumStatistics();
  },

  mounted() { },

  methods: {
    GetStoreOrderNumStatistics() {
      let param = {};
      GetStoreOrderNumStatistics(param).then((res) => {
        if (res.code == 1) {
          this.loading = false;
          this.statisticData = res.data;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.store-statistic-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.header-line {
  width: 4px;
  height: 22px;
  background: linear-gradient(180deg, #409eff 0%, #67c23a 100%);
  border-radius: 2px;
  margin-right: 12px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  letter-spacing: 0.5px;
}

.statistic-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
}

.statistic-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 10px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(64, 158, 255, 0.15);
    border-color: #409eff;
  }
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  img {
    width: 32px;
    height: 32px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
}

.card-content {
  margin-left: 14px;
  flex: 1;
  min-width: 0;
}

.card-label {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-value {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  font-family: "Helvetica Neue", Arial, sans-serif;
}

@media (max-width: 1200px) {
  .statistic-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .statistic-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
